import React, { useEffect, useRef } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  filterBy,
  CompositeFilterDescriptor,
} from "@progress/kendo-data-query";
import {
  Grid as KendoGrid,
  GridColumn as Column,
  GridFilterChangeEvent,
  GridPageChangeEvent,
  GridCustomHeaderCellProps,
  GridCustomCellProps,
  GridCustomFilterCellProps,
} from "@progress/kendo-react-grid";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { HeaderThElement } from "@progress/kendo-react-data-tools";
import { Typography } from "@progress/kendo-react-common";
import { LoadingPanel } from "../../components/layout/Loading";
import { setCurrentPage, setPageLimit } from "../pagination/paginationSlice";
import CommonFilterCell from "../../components/common/GlobalCommonFilterCell";
import { checkAcessRights, formatIndianNumber } from "../../_helper/helper";
import {
  clearFilterWalletAmountReturn,
  setFilterWalletAmountReturn,
} from "./walletamountreturnSlice";
import { getAllWalletReturns } from "./services/walletamountreturn.services";
import ButtonCreate from "../../components/drawer/ButtonCreate";
import ExpandableText from "../../components/common/ExpandableText";
import { useLocation } from "react-router-dom";
import { INSERT_ACCESS } from "../../_contstants/common";

const WalletAmountReturn: React.FC = () => {
  const location = useLocation();
  const isAddAccess = checkAcessRights(location.pathname, INSERT_ACCESS);

  return (
    <>
      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "4px 20px 20px 0",
          }}
        >
          <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
            Wallet Amount Add / Return
          </Typography.h4>
          {isAddAccess && (
            <ButtonCreate
              label="Create Wallet Amount Add / Return"
              drawerName="walletamountreturnForm"
              drawerWidth={600}
            />
          )}
        </GridLayoutItem>
        <GridLayoutItem>
          <WalletAmountReturnGridComponent />
        </GridLayoutItem>
      </GridLayout>
    </>
  );
};

const WalletAmountReturnGridComponent: React.FC = () => {
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);
  // const isEditAccess = checkAcessRights(location.pathname, EDIT_ACCESS);

  const WalletAmountReturnList = useAppSelector(
    (state) => state.walletamountreturn.WalletAmountReturnList
  );
  const loading = useAppSelector((state) => state.walletamountreturn.loading);
  const FilterWalletAmountReturn = useAppSelector(
    (state) => state.walletamountreturn.FilterWalletAmountReturn
  );
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);

  useEffect(() => {
    return () => {
      dispatch(setCurrentPage(0));
      dispatch(clearFilterWalletAmountReturn());
    };
  }, []);

  useEffect(() => {
    const payload = {
      ...FilterWalletAmountReturn,
      Limit: +pageLimit,
      Skip: +currentPage * +pageLimit,
    };
    dispatch(getAllWalletReturns(payload));
  }, [currentPage, pageLimit]);

  const [filter, setFilter] = React.useState<
    CompositeFilterDescriptor | undefined
  >(undefined);

  const pageChange = (event: GridPageChangeEvent) => {
    const newPage = event.page.skip / event.page.take;
    dispatch(setPageLimit(event.page.take));
    dispatch(setCurrentPage(newPage));
  };

  // const MyEditCommandCell = (props: any) => {
  //   const handleView = (UserID: number) => {
  //     navigate("/adminwallettransaction", {
  //       state: {
  //         UserID: UserID,
  //       },
  //     });
  //   };

  //   return (
  //     <td
  //       {...props.tdProps}
  //       className={`action-td ${props.className}`}
  //       style={{ ...props.tdProps.style }}
  //     >
  //       {/* {isEditAccess && ( */}
  //       <IconButton
  //         type="button"
  //         fillMode="flat"
  //         themeColor="tertiary"
  //         size="small"
  //         title="View"
  //         onClick={() => handleView(props.dataItem.UserID)}
  //       >
  //         <FaEye className="absolute-position" style={{ fontSize: "20px" }} />
  //       </IconButton>
  //       {/* )} */}
  //     </td>
  //   );
  // };

  const handleFilterChange = (e: GridFilterChangeEvent) => {
    setFilter(e.filter);
  };

  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      className={`table-header ${props.index === 5 ? "locked-header" : ""}`}
    >
      {props.children}
    </HeaderThElement>
  );
  const CustomCell = (props: any) => {
    return (
      <td {...props.tdProps} colSpan={1} className={"table-cell"}>
        {props.children}
      </td>
    );
  };
  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props} />
  );

  const WalletAmountReturnFilterCell = React.useCallback(
    (props: GridCustomFilterCellProps) => (
      <CommonFilterCell
        {...props}
        filterSelector={(state) =>
          state.walletamountreturn.FilterWalletAmountReturn
        }
        setFilterAction={setFilterWalletAmountReturn}
        clearFilterAction={clearFilterWalletAmountReturn}
        fetchDataAction={getAllWalletReturns}
        pagination={{ case: "capitalize" }}
      />
    ),
    []
  );

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}

      <KendoGrid
        scrollable="scrollable"
        style={{ maxHeight: "calc(100vh - 152px)" }}
        className="responsive-table"
        filterable={true}
        filter={filter}
        data={
          filter
            ? filterBy(WalletAmountReturnList, filter)
            : WalletAmountReturnList
        }
        onFilterChange={handleFilterChange}
        total={
          WalletAmountReturnList[0]?.ItemCount || WalletAmountReturnList.length
        }
        skip={currentPage * pageLimit}
        take={pageLimit}
        pageable={{
          buttonCount: 5,
          pageSizes: [10, 50, 100, 300, 500],
          pageSizeValue: pageLimit,
          type: "input",
        }}
        onPageChange={pageChange}
        cells={{
          headerCell: HeaderCustomCell,
          data: MyDataCustomCell,
        }}
      >
        <Column
          field="WalletAmountReturnNo"
          title="No"
          width={90}
          filterable={false}
        />
        <Column
          field="ReturnDate"
          title="Date"
          width={100}
          cells={{
            filterCell: WalletAmountReturnFilterCell,
          }}
        />
        <Column
          field="UserName"
          title="Customer Name"
          width={140}
          cells={{
            filterCell: WalletAmountReturnFilterCell,
          }}
        />
        <Column
          field="MobileNo"
          title="Mobile No"
          width={120}
          cells={{
            filterCell: WalletAmountReturnFilterCell,
          }}
        />
        <Column
          field="Amount"
          title="Amount"
          width={100}
          cells={{
            filterCell: WalletAmountReturnFilterCell,
            data: (props) => (
              <td className="text-end fw-bold">
                ₹ {formatIndianNumber(props.dataItem.Amount || 0)}
              </td>
            ),
          }}
        />
        <Column
          field="ReturnBalanceType"
          title="Add / Return Type"
          width={150}
          cells={{
            filterCell: WalletAmountReturnFilterCell,
          }}
        />
        <Column
          field="EntryType"
          title="Entry Type"
          width={120}
          cells={{
            filterCell: WalletAmountReturnFilterCell,
          }}
        />
        <Column
          field="Remarks"
          title="Remarks"
          width={300}
          cells={{
            data: (props) =>
              props.dataItem.Remarks ? (
                <ExpandableText text={props.dataItem.Remarks} />
              ) : (
                <td></td>
              ),
          }}
        />
      </KendoGrid>
    </>
  );
};

export default WalletAmountReturn;
